var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueTinymce',{attrs:{"id":"tinymce","setting":_vm.setting},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('div',{staticStyle:{"margin-top":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }